import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const VerifiedLicensesIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(
  ({ size = 24, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 33 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M12.6664 21.3328H3.33326C1.49597 21.3328 0 19.8368 0 17.9995V3.33324C0 1.49596 1.49597 0 3.33326 0H28.666C30.5033 0 31.9993 1.49596 31.9993 3.33324V15.3329C31.9993 15.7009 31.7006 15.9996 31.3326 15.9996C30.9646 15.9996 30.666 15.7009 30.666 15.3329V3.33324C30.666 2.23061 29.7687 1.3333 28.666 1.3333H3.33326C2.23062 1.3333 1.3333 2.23061 1.3333 3.33324V17.9995C1.3333 19.1022 2.23062 19.9995 3.33326 19.9995H12.6664C13.0344 19.9995 13.333 20.2981 13.333 20.6661C13.333 21.0341 13.0344 21.3328 12.6664 21.3328Z"
          fill="currentColor"
        />
        <path
          d="M15.9999 14.6678C13.7946 14.6678 12 12.8731 12 10.6679C12 8.46259 13.7946 6.66797 15.9999 6.66797C18.2052 6.66797 19.9998 8.46259 19.9998 10.6679C19.9998 12.8731 18.2052 14.6678 15.9999 14.6678ZM15.9999 8.00127C14.5293 8.00127 13.3333 9.19724 13.3333 10.6679C13.3333 12.1385 14.5293 13.3345 15.9999 13.3345C17.4705 13.3345 18.6665 12.1385 18.6665 10.6679C18.6665 9.19724 17.4705 8.00127 15.9999 8.00127Z"
          fill="currentColor"
        />
        <path
          d="M23.3344 32.0008C18.5559 32.0008 14.668 28.1129 14.668 23.3344C14.668 18.5559 18.5559 14.668 23.3344 14.668C28.113 14.668 32.0009 18.5559 32.0009 23.3344C32.0009 28.1129 28.113 32.0008 23.3344 32.0008ZM23.3344 16.0013C19.2905 16.0013 16.0013 19.2905 16.0013 23.3344C16.0013 27.3783 19.2905 30.6675 23.3344 30.6675C27.3783 30.6675 30.6676 27.3783 30.6676 23.3344C30.6676 19.2905 27.3783 16.0013 23.3344 16.0013Z"
          fill="currentColor"
        />
        <path
          d="M21.9996 26.6668C21.8236 26.6668 21.6529 26.5961 21.5276 26.4721L18.861 23.8055C18.601 23.5455 18.601 23.1229 18.861 22.8629C19.121 22.6029 19.5437 22.6029 19.8037 22.8629L21.9663 25.0255L26.1635 20.2283C26.4062 19.9496 26.8275 19.9229 27.1048 20.1656C27.3822 20.4083 27.4102 20.8296 27.1675 21.1069L22.5009 26.4401C22.3796 26.5788 22.2049 26.6614 22.0209 26.6668C22.0143 26.6668 22.0063 26.6668 21.9996 26.6668Z"
          fill="currentColor"
        />
        <path
          d="M7.33326 5.33525H4.66665C4.29866 5.33525 4 5.03659 4 4.6686C4 4.30061 4.29866 4.00195 4.66665 4.00195H7.33326C7.70125 4.00195 7.99991 4.30061 7.99991 4.6686C7.99991 5.03659 7.70125 5.33525 7.33326 5.33525Z"
          fill="currentColor"
        />
      </svg>
    )
  },
)

VerifiedLicensesIcon.displayName = 'VerifiedLicensesIcon'
